import { canonicalizeDataGridFilters } from './url-state'
import type { DataGridCriteria, DataGridFilter, DataGridParameterValue, DataGridSort } from './types'

export type DataGridTableSearch = { query: string; columns?: readonly string[] }

/** The table a user sees, with every grid default filled in. */
export type DataGridTable = {
  filters: readonly DataGridFilter[]
  columns: readonly string[]
  sort: readonly DataGridSort[]
  search?: DataGridTableSearch
  parameters: Readonly<Record<string, DataGridParameterValue>>
}

/** Mirrors the grid query, which ignores search text shorter than the grid minimum. */
export function appliedDataGridSearch(
  search: DataGridCriteria['search'],
  minimumLength: number,
): DataGridTableSearch | undefined {
  const query = search?.query?.trim()
  if (!query || query.length < minimumLength) return undefined
  return search?.columns?.length ? { query, columns: [...search.columns].sort() } : { query }
}

export function sameDataGridTable(left: DataGridTable, right: DataGridTable): boolean {
  return JSON.stringify(tableIdentity(left)) === JSON.stringify(tableIdentity(right))
}

function tableIdentity(table: DataGridTable) {
  return [
    canonicalizeDataGridFilters(table.filters),
    table.columns,
    table.sort.map(({ column, direction }) => [column, direction]),
    table.search ? [table.search.query, [...table.search.columns ?? []].sort()] : null,
    Object.keys(table.parameters).sort().map((id) => [id, table.parameters[id]]),
  ]
}
